/**
 * Rounds a number to the nearest integer, with half-way values (|x| mod 1 === 0.5) rounded away from zero.
 * This differs from `Math.round`, which rounds -0.5 toward zero (to -0) instead of -1.
 *
 * Examples:
 *   roundAwayFromZero(2.5)   →  3
 *   roundAwayFromZero(-2.5)  → -3
 *   roundAwayFromZero(2.4)   →  2
 *   roundAwayFromZero(-2.4)  → -2
 */
export function roundAwayFromZero(value: number): number {
  return Math.sign(value) * Math.round(Math.abs(value)) || 0;
}
